import { useEffect, useRef } from 'react';
import { Toaster, toast } from 'sonner';
import { useToastStore } from '@/stores/toast.store';
import { useHaptics } from '@/lib/haptics';
import { CompletionMark } from './CompletionMark';
import './toast.css';

/** One shared action nudge, including while a modal is open or a route changes. */
export function ToastViewport() {
  const toasts = useToastStore((s) => s.toasts);
  const last = useRef(0);
  const vibrate = useHaptics();
  useEffect(() => {
    const latest = toasts.at(-1);
    if (!latest || latest.id <= last.current) return;
    last.current = latest.id;
    // Detailed feature messages replace generic mutation feedback, avoiding duplicate nudges.
    toast[latest.tone](latest.message, {
      id: 'action-feedback',
      duration: latest.tone === 'error' ? 7000 : 4000,
      icon:
        latest.tone === 'success' && latest.feedback ? (
          <CompletionMark key={latest.id} kind={latest.feedback} />
        ) : undefined,
    });
    if (latest.tone === 'error') vibrate(50);
    useToastStore.setState({ toasts: [] });
  }, [toasts, vibrate]);
  return (
    <Toaster
      position="top-right"
      closeButton
      visibleToasts={1}
      gap={8}
      offset={{ top: 80, right: 24 }}
      mobileOffset={{ top: 80, left: 16, right: 16 }}
      toastOptions={{ className: 'finbob-toast' }}
    />
  );
}
